<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import util from '../src/libs/util'
export default {
  name: 'app',
  created() {
    util.initUserTheme()
    util.changeTheme()
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue